import { render, staticRenderFns } from "./PartialsLoader.vue?vue&type=template&id=12db1c84&scoped=true&"
import script from "./PartialsLoader.vue?vue&type=script&lang=js&"
export * from "./PartialsLoader.vue?vue&type=script&lang=js&"
import style0 from "./PartialsLoader.vue?vue&type=style&index=0&id=12db1c84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12db1c84",
  null
  
)

export default component.exports